module.exports = __webpack_public_path__ + "img/cart.3bcfddf7.svg";